// Web module: frameworks. Frameworks and requirements (L1 compliance core). Entities: framework, requirement.
//   /frameworks           FrameworksPage: cards with readiness, Controls / Requirements toggle, available frameworks
//   /frameworks/:slug     FrameworkDetailPage: counters, requirements table, scope with cascade preview, CSV downloads
//   /requirements/:id     generic detail page plus a "Mapped controls" tab (map, unmap, scope)
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    framework: {
      ListPage: lazyComponent(() => import('./FrameworksPage'), 'FrameworksPage'),
      DetailPage: lazyComponent(() => import('./FrameworkDetailPage'), 'FrameworkDetailPage'),
    },
    requirement: {
      detailTabs: [
        {
          id: 'controls',
          label: 'Mapped controls',
          order: 15,
          component: lazyComponent(() => import('./RequirementControlsTab'), 'RequirementControlsTab'),
        },
      ],
      hideDefaultTabs: ['links'],
    },
  },
}
